import * as React from 'react';
import {
  FOCUS_RING_BRAND_SHADOW_SM,
  FOCUS_RING_ERROR_SHADOW_XS,
} from '../styles/common';
import { cn } from '../utils';
import type { InputProps } from './input';

export type AffixedInputProps = InputProps & {
  prefix?: string;
  suffix?: string;
  icon?: React.ReactNode;
};
export const AffixedInput = React.forwardRef<
  HTMLInputElement,
  AffixedInputProps
>(({ className, type, destructive, prefix, suffix, icon, ...props }, ref) => {
  return (
    <div className={cn('flex items-center text-md text-secondary', className)}>
      {prefix && (
        <p
          className={cn(
            'h-10 rounded-s-md border-y border-s border-primary px-4 py-2.5 leading-none text-tertiary',
            props.disabled && 'cursor-not-allowed opacity-50',
          )}
        >
          {prefix}
        </p>
      )}
      <div className={cn('relative')}>
        <input
          className={cn(
            // For icon spacing
            'pe-8',
            // Default
            'flex h-10 w-full border bg-primary ps-3.5 text-primary shadow-xs transition placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50',
            // File
            'file:border-0 file:bg-transparent file:font-medium',
            // Focus
            destructive || props['aria-invalid']
              ? [`border-error-500`, FOCUS_RING_ERROR_SHADOW_XS]
              : [
                  'border-primary focus-visible:border-brand-300 dark:focus-visible:border-brand-900',
                  FOCUS_RING_BRAND_SHADOW_SM,
                ],
            !suffix && `rounded-e-md`,
            !prefix && `rounded-s-md`,
          )}
          ref={ref}
          type={type}
          {...props}
        />
        <span className="absolute end-2 top-1/2 -translate-y-1/2 bg-primary">
          {icon}
        </span>
      </div>
      {suffix && (
        <p
          className={cn(
            'h-10 rounded-e-md border-y border-e border-primary px-4 py-2.5 leading-none text-tertiary',
            props.disabled && 'cursor-not-allowed opacity-50',
          )}
        >
          {suffix}
        </p>
      )}
    </div>
  );
});

AffixedInput.displayName = 'AffixedInput';
